const RegisterReturnIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2217_10900)" />
      <g clip-path="url(#clip0_2217_10900)">
        <path
          d="M35.7135 27.6567L24.2278 39.1424C23.8046 39.5664 23.5371 40.121 23.4688 40.7162L23.0112 44.7345C22.9813 45.0171 23.0114 45.3028 23.0995 45.5729C23.1876 45.8431 23.3317 46.0916 23.5224 46.3023C23.713 46.513 23.946 46.6811 24.206 46.7956C24.4661 46.9101 24.7473 46.9685 25.0315 46.9669H25.2659L29.2842 46.5093C29.877 46.4407 30.4304 46.1777 30.858 45.7614L42.3437 34.2646L35.7135 27.6567Z"
          fill="white"
        />
        <path
          d="M46.2279 26.6852L43.3146 23.772C43.0709 23.5273 42.7813 23.3331 42.4624 23.2007C42.1434 23.0682 41.8015 23 41.4561 23C41.1108 23 40.7689 23.0682 40.4499 23.2007C40.131 23.3331 39.8414 23.5273 39.5977 23.772L36.8965 26.4732L43.5267 33.1034L46.2279 30.4022C46.4726 30.1585 46.6667 29.8688 46.7992 29.5499C46.9317 29.231 46.9998 28.889 46.9998 28.5437C46.9998 28.1984 46.9317 27.8564 46.7992 27.5375C46.6667 27.2186 46.4726 26.9289 46.2279 26.6852Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2217_10900"
          x1="35"
          y1="0"
          x2="35"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A42747" />
          <stop offset="1" stop-color="#8A213C" />
        </linearGradient>
        <clipPath id="clip0_2217_10900">
          <rect width="24" height="24" fill="white" transform="translate(23 23)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default RegisterReturnIconSubcategory
